import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import GridWidget from './GridWidget';
import { actions as operationActions } from 'ducks/uiOperations';
import { IApplicationState } from 'ducks/reducers';
import { selectors as customerSelectors } from 'ducks/customer';
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup';

// const params = new URLSearchParams(location.search); // May use this for getting via search params

const mapStateToProps = (state: IApplicationState) => ({
    selectedCustomerId: customerSelectors.selected(state)?.CustomerId,
    selectedProductId: productSelectors.selected(state)?.ProductId
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeOperationMode: operationActions.changeOperationMode,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GridWidget);
